<template>
  <div>
    <div class="flex flex-wrap items-center gap-2">
      <span class="text-[11px] font-semibold uppercase tracking-wide text-slate-400">Quick actions</span>
      <kbd class="rounded-md border border-slate-200 bg-white px-1.5 py-0.5 text-[10px] font-medium text-slate-400">></kbd>
      <button
        v-for="command in chipCommands"
        :key="command.id"
        type="button"
        @click="$emit('run', command)"
        class="inline-flex items-center gap-1.5 rounded-full border px-3 py-1.5 text-xs font-medium transition-all"
        :class="isActive(command)
          ? 'border-rose-200 bg-rose-50 text-rose-700 shadow-sm'
          : 'border-slate-200 bg-white text-slate-600 hover:border-slate-300 hover:bg-slate-50'"
      >
        <span class="h-1.5 w-1.5 rounded-full" :class="isActive(command) ? 'bg-rose-500' : 'bg-slate-300'"></span>
        {{ command.title }}
      </button>
    </div>

    <div v-if="showList && commands.length" class="mt-3 space-y-1">
      <button
        v-for="(command, index) in commands"
        :key="command.id"
        type="button"
        @click="$emit('run', command)"
        class="flex w-full items-center justify-between rounded-xl border px-3 py-2.5 text-left transition-all"
        :class="selectedIndex === index
          ? 'border-rose-200 bg-rose-50 shadow-sm'
          : 'border-transparent bg-slate-50/80 hover:border-slate-200 hover:bg-white hover:shadow-sm'"
      >
        <div class="min-w-0">
          <p class="truncate text-sm font-medium text-slate-900">{{ command.title }}</p>
          <p class="truncate text-xs text-slate-500">{{ command.hint }}</p>
        </div>
        <span class="ml-3 shrink-0 rounded-md border border-slate-200 bg-white px-1.5 py-0.5 text-[10px] font-medium text-slate-400">
          {{ command.to || 'Open' }}
        </span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import { QUICK_COMMANDS } from './quickCommands'

const props = defineProps({
  commands: {
    type: Array,
    default: () => []
  },
  selectedIndex: {
    type: Number,
    default: -1
  },
  showList: {
    type: Boolean,
    default: false
  }
})

defineEmits(['run'])

const chipCommands = computed(() => QUICK_COMMANDS.filter(cmd => cmd.featured))

const isActive = (command) => {
  return props.commands.some(item => item.id === command.id) && props.showList
}
</script>
